import React, { useState } from 'react';
import { Check, Share2 } from 'lucide-react';

interface ShareButtonProps {
  url?: string;
  className?: string;
}

export const ShareButton: React.FC<ShareButtonProps> = ({
  url,
  className = '',
}) => {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const shareUrl = url || window.location.href;

    try {
      // Try to use the Clipboard API
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = shareUrl;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (fallbackErr) {
        console.error('Failed to copy URL:', fallbackErr);
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <button
      onClick={handleShare}
      className={`inline-flex items-center gap-2 bg-church-gold text-white px-4 py-2 rounded-md hover:bg-yellow-600 transition-colors font-medium ${className}`}
      title='Copier le lien'
    >
      {copied ? (
        <>
          <Check className='w-4 h-4' />
          <span>Lien copié!</span>
        </>
      ) : (
        <>
          <Share2 className='w-4 h-4' />
          <span>Partager</span>
        </>
      )}
    </button>
  );
};
